/*
 * Cart-icon flyout interceptor.
 * Active on the el-cabron template only (loaded conditionally from
 * snippets/cart-notification.liquid).
 *
 * Hooks the cart icon in the header so it opens the wan94-styled
 * cart-notification flyout (already in the DOM) with the current
 * cart contents, instead of navigating straight to /cart. Empty
 * cart falls back to the normal navigation since the flyout has
 * no empty-state view.
 *
 * Re-uses Ride's <cart-notification> custom element and its
 * existing open() method. Re-uses the Section Rendering API
 * pattern already used by cart-notification-controls.js.
 */
(function () {
  const SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

  function init() {
    const cartIcon = document.querySelector('.header__icon--cart');
    const notification = document.querySelector('cart-notification');
    if (!cartIcon || !notification) return;

    cartIcon.addEventListener('click', async (event) => {
      // Right-click / middle-click / cmd-click etc. — let the browser handle it
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      const fallback = () => {
        window.location.href = cartIcon.getAttribute('href') || '/cart';
      };

      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            updates: {},
            sections: SECTIONS,
            sections_url: window.location.pathname,
          }),
        });
        if (!res.ok) return fallback();
        const data = await res.json();

        // Empty cart: no flyout content to show, just go to /cart.
        if (!data.item_count || data.item_count === 0) return fallback();

        SECTIONS.forEach((id) => {
          const target = document.getElementById(id);
          if (!target || !data.sections || !data.sections[id]) return;
          const parsed = new DOMParser().parseFromString(data.sections[id], 'text/html');
          const sectionEl = parsed.querySelector('.shopify-section');
          target.innerHTML = sectionEl ? sectionEl.innerHTML : data.sections[id];
        });

        if (typeof notification.open === 'function') {
          notification.setActiveElement?.(cartIcon);
          notification.open();
        } else {
          const inner = notification.querySelector('.cart-notification');
          if (inner) inner.classList.add('active');
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('cart-icon-flyout: open failed', err);
        fallback();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
